<template>
  <div>
    <field-item
      @click="select(section.select(objectDynamicInput, endPoint, apiMessageType, path))"
      :disabled="handler.isDisabled(objectDynamicInput, parentTreeContext)"
    >
      <row>
        <prefix>
          <icon glyph="box"/>
        </prefix>
        <column>
          {{objectDynamicInput.name}}
        </column>
      </row>
    </field-item>

    <collapsible-section
      class="collapse-item"
      :id="`dynamicInputsCollapse-${handler.variable.id}-${objectDynamicInput.id}-properties`"
      control-name="apiEndPointPropertiesCollapse"
      :is-open="false"
    >
      <template #section-header>
        Properties
      </template>

      <template #section-contents>
        <field-item
          v-for="prop in section.properties"
          :key="prop.clientIdOrId"
          :disabled="handler.isDisabled(prop, computedChildTreeContext)"
          @click="select(section.select(prop, endPoint, apiMessageType, completePathFor(prop)))"
        >
          <row>
            <prefix>
              <icon :glyph="dynamicInputGlyph(prop)"/>
            </prefix>
            <column>
              {{prop.name}}
            </column>
          </row>
        </field-item>

        <collapsible-section
          v-for="prop in section.objects"
          class="collapse-item"
          :id="`dynamicInputsCollapse-${handler.variable.id}-${prop.id}`"
          control-name="apiEndPointObjectCollapse"
          :is-open="false"
          :key="prop.clientIdOrId"
        >
          <template #section-header>
            {{ prop.name }}
          </template>

          <template #section-contents>
            <api-object-data
              :handler="handler"
              :end-point="endPoint"
              :apiMessageType="apiMessageType"
              :object-dynamic-input="prop"
              :path="completePathFor(prop)"
              :q="lowerQ"
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            />
          </template>
        </collapsible-section>
      </template>
    </collapsible-section>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
import FieldItem from './common/field-item.vue';
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import {
  IDynamicTreeContext,
} from '~/interfaces/dynamicFieldsInterfaces'
import handlerTreeContextMixin from "~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin";
import ProcessFlowApiEndPointDynamicFieldsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowApiEndPointDynamicFieldsHandler";
import EndPoint from "../../../../formability/organization_settings/models/connections/endPoint";
import DynamicInput from "~/models/dynamicInput";
import CertificateDynamicInput from '../../../../formability/certificateBuilder/models/certificateDynamicInput'
import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue'
import {ProcessFlowDynamicInputIcons} from "../../../../formability/certificateBuilder/enums/certificateDynamicInputType";

export default Vue.extend({
  name: 'api-object-data',
  mixins: [handlerComponentsMixin, handlerTreeContextMixin],
  components: {
    FieldItem,
    CollapsibleSection,
  },
  props: {
    handler: {
      type: ProcessFlowApiEndPointDynamicFieldsHandler,
      required: true,
    },
    endPoint: {
      type: EndPoint,
      required: true,
    },
    apiMessageType: {
      type: String,
      required: true,
    },
    objectDynamicInput: {
      type: Object as () => CertificateDynamicInput,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      required: true,
    },
  },
  data: function () {
    return {
    };
  },
  computed: {
    section() {
      return this.handler.dynamicInputsSection(this.lowerQ, this.endpoint, this.apiMessageType, this.objectDynamicInput)
    },
    treeContext(): IDynamicTreeContext {
      return {
        parent: this.objectDynamicInput,
        isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.objectDynamicInput, this.parentTreeContext),
        referencePathNodesToLevel: this.path,
      }
    },
  },
  methods: {
    completePathFor(prop: DynamicInput): ReferencePathNode[] {
      if (!this.path) return null;
      return [
        ...this.path,
        new ReferencePathNode(null, {reference_type: ReferenceNodeType.DynamicInput, reference_id: prop.id}),
      ]
    },
    dynamicInputGlyph(dynamicInput: DynamicInput): string {
      return ProcessFlowDynamicInputIcons[dynamicInput.type];
    },
  },
});
</script>